/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type ArchiveIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let ArchiveIcon: NessieFunctionComponent<ArchiveIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.686 2.314H5.784a.661.661 0 00-.666.666v18.236a.66.66 0 00.666.666h12.902a.66.66 0 00.667-.666V2.98c.04-.353-.275-.666-.667-.666zm-.666 18.235H6.49v-8.118h11.53v8.118zm0-8.941H6.49V3.686h11.53v7.922zm-6.98 4.431h2.47a.393.393 0 00.392-.392v-1.255a.393.393 0 00-.784 0v.863H11.47v-.863a.393.393 0 00-.784 0v1.255c-.08.196.117.392.352.392z"
          />
          <mask maskUnits="userSpaceOnUse" x={5} y={2} width={15} height={20}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.686 2.314H5.784a.661.661 0 00-.666.666v18.236a.66.66 0 00.666.666h12.902a.66.66 0 00.667-.666V2.98c.04-.353-.275-.666-.667-.666zm-.666 18.235H6.49v-8.118h11.53v8.118zm0-8.941H6.49V3.686h11.53v7.922zm-6.98 4.431h2.47a.393.393 0 00.392-.392v-1.255a.393.393 0 00-.784 0v.863H11.47v-.863a.393.393 0 00-.784 0v1.255c-.08.196.117.392.352.392z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
ArchiveIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  ArchiveIcon = nessiePropCheckerWrapper(ArchiveIcon);
}

export default ArchiveIcon;
